export default __webpack_public_path__ + "static/media/thumbs-down-filled.31a8f08c.svg";